import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RED    = '#DC143C';
const GOLD   = '#D4AF37';
const DARK   = '#0a0404';
const BORDER = 'rgba(255,255,255,0.1)';
const MUTED  = 'rgba(255,255,255,0.35)';
const WHITE  = '#ffffff';
const PURPLE = '#6660fe';

const STYLES = `
  @keyframes magmaPulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(220,20,60,0.4); }
    50%       { box-shadow: 0 0 0 8px rgba(220,20,60,0); }
  }
  .magma-cta-btn {
    animation: magmaPulse 2s ease-in-out infinite;
    transition: transform 0.15s ease, background 0.15s ease;
  }
  .magma-cta-btn:hover {
    animation-play-state: paused;
    transform: scale(1.02);
  }
  .magma-tier-card {
    transition: border-color 0.2s ease, transform 0.2s ease;
  }
  .magma-tier-card:hover {
    transform: translateY(-2px);
  }
  .magma-table { width: 100%; border-collapse: collapse; margin-bottom: 40px; }
  .magma-table th {
    font-family: 'IBM Plex Mono', monospace;
    font-size: 9px; font-weight: 700; letter-spacing: 0.18em;
    text-transform: uppercase; color: ${MUTED};
    padding: 10px 14px; border-bottom: 1px solid rgba(255,255,255,0.08);
    text-align: center; background: rgba(255,255,255,0.02);
  }
  .magma-table th:first-child { text-align: left; }
  .magma-table td {
    padding: 9px 14px; border-bottom: 1px solid rgba(255,255,255,0.05);
    font-family: 'IBM Plex Mono', monospace; font-size: 11px; color: rgba(255,255,255,0.6);
  }
  .magma-table td.feat-name { color: rgba(255,255,255,0.85); font-weight: 500; }
  .magma-table td.ok     { color: #22c55e; text-align: center; font-weight: 700; }
  .magma-table td.no     { color: rgba(255,255,255,0.15); text-align: center; }
  .magma-table td.partial{ color: ${GOLD}; text-align: center; font-size: 10px; }
  .magma-table tr.group-row td {
    background: rgba(255,255,255,0.03);
    font-family: 'IBM Plex Mono', monospace;
    font-size: 8px; font-weight: 700; letter-spacing: 0.2em;
    text-transform: uppercase; color: rgba(255,255,255,0.25); padding: 7px 14px;
  }
  .magma-table tbody tr:hover td { background: rgba(255,255,255,0.02); }
`;

export default function Assinar() {
  const { user } = useAuth();

  return (
    <div style={{ background: DARK, minHeight: "100vh", fontFamily: "'IBM Plex Mono', monospace" }}>
      <style>{STYLES}</style>

      {/* ── Hero ── */}
      <div style={{ maxWidth: 900, margin: "0 auto", padding: "80px 40px 64px", textAlign: "center" }}>
        <div style={{
          fontSize: 9, fontWeight: 700, color: RED,
          letterSpacing: "0.28em", textTransform: "uppercase", marginBottom: 20,
        }}>Planos & Assinaturas</div>

        {/* Logo */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 20 }}>
          <span style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 42, fontWeight: 800, color: WHITE, letterSpacing: "-0.04em", borderBottom: `3px solid ${RED}`, paddingBottom: 2 }}>RR</span>
          <div style={{ width: 1, height: 32, background: "rgba(220,20,60,0.4)" }} />
          <span style={{ fontSize: 24, fontWeight: 800, letterSpacing: "0.2em", background: "linear-gradient(90deg,#FF4500,#FF6A00,#FFB300)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>MAGMA</span>
        </div>

        <h1 style={{
          fontFamily: "'IBM Plex Serif', Georgia, serif",
          fontSize: "clamp(28px, 5vw, 48px)",
          color: WHITE, lineHeight: 1.1,
          letterSpacing: "-0.03em", marginBottom: 16,
        }}>
          Inteligência que<br />
          <span style={{ color: RED, fontStyle: "italic" }}>você controla</span>
        </h1>
        <p style={{ fontSize: 13, color: MUTED, lineHeight: 1.7, maxWidth: 500, margin: "0 auto 36px" }}>
          Uma conta. Dois produtos. Acesso progressivo ao RR Site e RR Magma conforme seu plano.
        </p>
        <div style={{ width: 40, height: 2, background: RED, margin: "0 auto" }} />
      </div>

      {/* ── Tier cards ── */}
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 40px 80px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 20 }}>

          <TierCard
            tag="Logado G"
            tagColor={PURPLE}
            name="Conta Gratuita"
            price="Grátis"
            desc="Feed completo, TV, agenda, balanços, newsletter."
            features={[
              { ok: true,  label: "80% do feed de notícias" },
              { ok: true,  label: "RR TV completo" },
              { ok: true,  label: "Agenda macro 5 dias" },
              { ok: true,  label: "Balanços corporativos" },
              { ok: false, label: "Análise política completa" },
              { ok: false, label: "Cenários / Fatores de Risco" },
              { ok: false, label: "Magma deep (sub-páginas)" },
            ]}
            cta="Criar conta"
            ctaHref="/entrar"
            featured={false}
            current={user && user.tier === 1}
          />

          <TierCard
            tag="Tier 1"
            tagColor={RED}
            name="RR + Magma"
            price="~R$ 40"
            priceSub="/mês"
            desc="RR completo + Magma dashboard integral."
            features={[
              { ok: true,  label: "Tudo do Logado G" },
              { ok: true,  label: "Análise política completa" },
              { ok: true,  label: "Cenários + Fatores de Risco" },
              { ok: true,  label: "Magma: FX, cripto, B3, bonds" },
              { ok: true,  label: "Curva de Juros + COPOM" },
              { ok: true,  label: "Histórico 30d" },
              { ok: false, label: "Genoma · Histórico longo" },
            ]}
            cta="Assinar Tier 1"
            ctaHref="/entrar"
            featured
            current={user && user.tier === 2}
          />

          <TierCard
            tag="Tier 3 — Full Magma"
            tagColor={GOLD}
            name="Full Magma"
            price="~R$ 100"
            priceSub="/mês"
            desc="Genoma, Surveillance completo, histórico longo, exportação."
            features={[
              { ok: true,   label: "Tudo do Tier 1" },
              { ok: true,   label: "RR Genoma (Siscomex/NCM)" },
              { ok: true,   label: "RR Surveillance (completo)" },
              { ok: true,   label: "Histórico longo (>1 ano)" },
              { ok: true,   label: "Polymarket + Exportação" },
              { ok: true,   label: "Magma full (todas sub-páginas)" },
              { ok: "beta", label: "RR Research (beta)" },
            ]}
            cta="Assinar Tier 3"
            ctaHref="/entrar"
            featured={false}
            current={user && user.tier === 3}
          />

        </div>
      </div>

      {/* ── Feature matrix ── */}
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "0 40px 80px" }}>
        <div style={{ fontSize: 8, fontWeight: 700, letterSpacing: "0.28em", textTransform: "uppercase", color: MUTED, marginBottom: 32, display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ display: "block", width: 24, height: 1, background: MUTED }} />
          Comparativo completo
        </div>
        <h2 style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 28, color: WHITE, letterSpacing: "-0.02em", marginBottom: 40 }}>
          O que está incluso em cada plano
        </h2>

        {/* RR Site */}
        <table className="magma-table">
          <thead>
            <tr>
              <th style={{ width: 260 }}>Funcionalidade</th>
              <th>Aberto</th>
              <th>Logado G</th>
              <th>Tier 1</th>
              <th>Tier 3</th>
            </tr>
          </thead>
          <tbody>
            <tr className="group-row"><td colSpan="5">RR Site — editorial</td></tr>
            <tr><td className="feat-name">Notícias (feed)</td><td className="partial">≈80%</td><td className="ok">80% (sem popup)</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">RR Day After</td><td className="ok">✓</td><td className="ok">✓</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">RR TV</td><td className="ok">✓</td><td className="ok">✓</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Alertas</td><td className="partial">3 alertas</td><td className="partial">5 alertas</td><td className="ok">Todas classes</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Cenários</td><td className="partial">1 cenário</td><td className="partial">1 c/ gamif.</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Genoma</td><td className="partial">1 produto</td><td className="no">—</td><td className="no">—</td><td className="ok">✓</td></tr>
            <tr className="group-row"><td colSpan="5">RR Magma — dashboard</td></tr>
            <tr><td className="feat-name">Hero + Altas/Baixas</td><td className="ok">✓</td><td className="ok">✓</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Selic · COPOM · Curva de Juros</td><td className="partial">básico</td><td className="ok">✓</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Câmbio Geopolítico (/fx)</td><td className="ok">✓</td><td className="no">—</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Crypto Dashboard</td><td className="ok">✓</td><td className="no">—</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Painel B3 / Bonds</td><td className="no">—</td><td className="no">—</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Histórico 30d</td><td className="no">—</td><td className="no">—</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">RR Genoma (Siscomex)</td><td className="no">—</td><td className="no">—</td><td className="no">—</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">RR Surveillance</td><td className="no">—</td><td className="no">—</td><td className="partial">top teses</td><td className="ok">✓ completo</td></tr>
            <tr><td className="feat-name">Histórico longo (&gt;1 ano)</td><td className="no">—</td><td className="no">—</td><td className="no">—</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Polymarket · Exportação</td><td className="no">—</td><td className="no">—</td><td className="no">—</td><td className="ok">✓</td></tr>
          </tbody>
        </table>

        {/* Emails */}
        <table className="magma-table">
          <thead>
            <tr>
              <th style={{ width: 260 }}>Emails & Notificações</th>
              <th>Cadastrado</th>
              <th>Tier 1</th>
              <th>Tier 3</th>
            </tr>
          </thead>
          <tbody>
            <tr><td className="feat-name">Newsletter da manhã</td><td className="partial">✓ (10:30)</td><td className="ok">✓ (7:30)</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">RR Day After (17h)</td><td className="ok">✓</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Giro Internacional</td><td className="partial">1x ao dia</td><td className="partial">2x ao dia</td><td className="ok">3x ao dia</td></tr>
            <tr><td className="feat-name">Agenda do dia</td><td className="no">—</td><td className="ok">✓</td><td className="ok">✓</td></tr>
            <tr><td className="feat-name">Alerta real-time</td><td className="partial">1x/dia (15min atraso)</td><td className="partial">3x/dia</td><td className="ok">✓ real-time</td></tr>
            <tr><td className="feat-name">Resumo semanal</td><td className="no">—</td><td className="ok">✓</td><td className="ok">✓</td></tr>
          </tbody>
        </table>
      </div>

      {/* ── Unified auth box ── */}
      <div style={{ background: "rgba(255,255,255,0.02)", borderTop: `1px solid ${BORDER}`, borderBottom: `1px solid ${BORDER}`, padding: "60px 40px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48 }}>
          <div>
            <h3 style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 28, color: WHITE, lineHeight: 1.2, marginBottom: 16 }}>
              Uma conta.<br />Dois produtos.
            </h3>
            <p style={{ fontSize: 12, color: MUTED, lineHeight: 1.8 }}>
              RR Site e RR Magma compartilham a mesma autenticação. Assinar qualquer plano desbloqueia o nível equivalente em ambos automaticamente.
            </p>
          </div>
          <ul style={{ listStyle: "none", padding: 0, display: "flex", flexDirection: "column", gap: 14 }}>
            {[
              { tag: "Aberto",    color: MUTED,   text: "Manchetes + hero Magma sempre visíveis." },
              { tag: "Logado G",  color: PURPLE,  text: "Feed completo no RR · home Magma sem sub-páginas." },
              { tag: "Tier 1",    color: RED,     text: "RR integral + Magma dashboard completo." },
              { tag: "Tier 3",    color: GOLD,    text: "Genoma, Surveillance, histórico longo, exportação." },
            ].map((item) => (
              <li key={item.tag} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 8, fontWeight: 700, letterSpacing: "0.15em", padding: "3px 8px", borderRadius: 3, background: item.color + "22", color: item.color, flexShrink: 0, marginTop: 2 }}>{item.tag}</span>
                <span style={{ fontSize: 12, color: MUTED, lineHeight: 1.6 }}>{item.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* ── Footer CTA ── */}
      <div style={{ textAlign: "center", padding: "60px 40px" }}>
        <div style={{ fontSize: 9, color: MUTED, letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: 16 }}>Comece agora</div>
        <Link to="/entrar" className="magma-cta-btn" style={{
          display: "inline-block", padding: "16px 40px",
          background: RED, color: WHITE, borderRadius: 6,
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 12, fontWeight: 800, letterSpacing: "0.12em",
          textTransform: "uppercase", textDecoration: "none",
        }}>Criar conta gratuita →</Link>
        <div style={{ marginTop: 16, fontSize: 11, color: MUTED }}>
          Já tem conta?{" "}
          <Link to="/entrar" style={{ color: GOLD, textDecoration: "none", fontWeight: 700 }}>Entrar →</Link>
        </div>
      </div>

    </div>
  );
}

function TierCard({ tag, tagColor, name, price, priceSub, desc, features, cta, ctaHref, featured, current }) {
  return (
    <div className="magma-tier-card" style={{
      borderRadius: 10, overflow: "hidden",
      border: featured ? `1px solid ${RED}` : `1px solid ${BORDER}`,
      background: featured ? "rgba(220,20,60,0.05)" : "rgba(255,255,255,0.02)",
      boxShadow: featured ? "0 8px 32px rgba(220,20,60,0.15)" : "none",
      display: "flex", flexDirection: "column",
    }}>
      <div style={{
        padding: "24px 24px 18px",
        background: featured ? "rgba(220,20,60,0.08)" : "rgba(255,255,255,0.02)",
        borderBottom: `1px solid ${BORDER}`,
      }}>
        <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 8, fontWeight: 700, letterSpacing: "0.2em", textTransform: "uppercase", padding: "3px 8px", borderRadius: 100, background: tagColor + "22", color: tagColor, display: "inline-block", marginBottom: 12 }}>{tag}</span>
        <div style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 22, color: WHITE, marginBottom: 6 }}>{name}</div>
        <div style={{ fontFamily: "'IBM Plex Serif', Georgia, serif", fontSize: 32, color: WHITE, lineHeight: 1 }}>
          {price}
          {priceSub && <span style={{ fontSize: 13, fontFamily: "'IBM Plex Mono', monospace", fontWeight: 300, color: MUTED }}>{priceSub}</span>}
        </div>
        <div style={{ fontSize: 11, color: MUTED, marginTop: 8 }}>{desc}</div>
      </div>

      <div style={{ padding: "18px 24px", flex: 1 }}>
        {features.map((f, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "6px 0", borderBottom: `1px solid rgba(255,255,255,0.04)`, fontSize: 11, color: f.ok === true ? "rgba(255,255,255,0.8)" : f.ok === "beta" ? MUTED : "rgba(255,255,255,0.2)" }}>
            <span style={{ fontSize: 12, color: f.ok === true ? "#22c55e" : f.ok === "beta" ? GOLD : "rgba(255,255,255,0.15)" }}>
              {f.ok === true ? "✓" : f.ok === "beta" ? "~" : "—"}
            </span>
            {f.label}
          </div>
        ))}
      </div>

      <div style={{ padding: "0 24px 24px" }}>
        {current ? (
          <div style={{ width: "100%", padding: "12px", textAlign: "center", background: "rgba(34,197,94,0.1)", color: "#22c55e", border: "1px solid rgba(34,197,94,0.2)", borderRadius: 6, fontFamily: "'IBM Plex Mono', monospace", fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase" }}>
            Plano atual ✓
          </div>
        ) : (
          <Link to={ctaHref} className={featured ? "magma-cta-btn" : ""} style={{
            display: "block", width: "100%", padding: "12px", textAlign: "center",
            background: featured ? RED : "transparent",
            color: featured ? WHITE : MUTED,
            border: featured ? "none" : `1px solid ${BORDER}`,
            borderRadius: 6, textDecoration: "none",
            fontFamily: "'IBM Plex Mono', monospace",
            fontSize: 10, fontWeight: 700, letterSpacing: "0.1em",
            textTransform: "uppercase", boxSizing: "border-box",
          }}>{cta}</Link>
        )}
      </div>
    </div>
  );
}
